<span class="fa-stack stack-left">
  <i class="fas fa-arrow-to-right fa-stack-1x"></i>
  <i class="fal fa-circle fa-stack-2x"></i>
</span>
<span [style.width]="percentage" class="progress-status"></span>
<span class="line-bar"></span>
<span class="fa-stack stack-right">
  <i class="fas fa-arrow-from-left fa-stack-1x"></i>
  <i class="fal fa-circle fa-stack-2x"></i>
</span>
